module.exports = __webpack_public_path__ + "static/media/gu.40df2527.svg";